import { render, staticRenderFns } from "./architecture-drivers-ruleset.vue?vue&type=template&id=be0bef32&scoped=true"
import script from "./architecture-drivers-ruleset.vue?vue&type=script&lang=js"
export * from "./architecture-drivers-ruleset.vue?vue&type=script&lang=js"
import style0 from "./architecture-drivers-ruleset.vue?vue&type=style&index=0&id=be0bef32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0bef32",
  null
  
)

export default component.exports